import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  titleSection: {
    padding: '26px 28px 19px 28px',
    backgroundColor: '#064e75',
  },
  titleColor: {
    backgroundColor: '#064e75',
  },
  contentSection: {
    padding: '0 0 0 0',
  },
  footerSection: {
    justifyContent: 'space-between',
    padding: '0px 29px 24px 29px',
  },
  dialogWrapper: {
    '& .MuiDialog-paper': {
      maxWidth: 760,
    },
  },

  titleSectionWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  titleSectionLeftSide: {
    display: 'flex',
  },
  titleSectionLeftSideImage: {
    width: '94px',
    height: '94px',
    position: 'relative',
    flex: '0 0 auto',
    '& img': {
      maxWidth: '94px',
      maxHeight: '94px',
      borderRadius: '50%',
      overflow: 'hidden',
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      margin: 'auto',
    },
  },
  titleSectionLeftSideData: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginLeft: 22,
  },
  titleSectionLeftSideDataName: {
    fontSize: 22,
    fontWeight: 'bold',
    color: '#ffffff',
  },
  titleSectionLeftSideDataGroups: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: 12,
    width: 424,
    maxHeight: 82,
    overflowY: 'auto',
    flexDirection: 'column',
    '&::-webkit-scrollbar': {
      width: 10,
      height: 10,
    },
    '&::-webkit-scrollbar-track': {
      background: 'rgb(241 241 241)',
      borderRadius: 10,
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'rgb(168 168 168 / 90%)',
      borderRadius: 10,
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: 'rgb(168 168 168)',
    },
  },
  groupItem: {
    borderRadius: 8,
    border: 'solid 1px #ffffff',
    marginBottom: 8,
    marginRight: 8,
    padding: '8px 12px',
    textAlign: 'center',
    cursor: 'pointer',
  },
  groupItemName: {
    fontSize: 14,
    fontWeight: 500,
    color: '#ffffff',
  },
  groupItemSubName: {
    fontSize: 9,
    color: '#89f1ff',
  },

  titleSectionRightSide: {
    display: 'flex',
    color: '#ffffff',
    '& svg': {
      marginLeft: 7,
      cursor: 'pointer',
    },
  },

  contentSectionWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  subscriberDetails: {
    display: 'flex',
    flexDirection: 'column',
    padding: '27px 29px 20px 29px',
    borderBottom: 'solid 1px #e5e5e5',
  },
  subscriberDetailsTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#404040',
    display: 'flex',
    alignItems: 'center',
  },
  subscriberDetailsHead: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  subscriberDetailsHeadRightSide: {},
  subscriberDetailsHelp: {
    color: '#0073b1',
    display: 'flex',
    alignItems: 'center',
    '& svg': {},
    '& span': {
      textDecoration: 'underline',
      fontSize: 16,
      marginLeft: 4,
    },
  },
  subscriberDetailsStatus: {
    '& > div': {
      marginLeft: 15,
      fontWeight: 'normal',
      padding: '17px 27px',
    },
  },
  subscriberDetailsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 19,
  },
  subscriberDetailsItem: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 17,
    '& img': {
      width: 24,
      height: 24,
      borderRadius: '50%',
    },
    '& svg': {
      width: '2.5rem',
      height: '2.5rem',
      marginRight: 16,
    },
  },
  subscriberDetailsProfile: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 17,
    '& svg': {
      marginRight: 16,
    },
  },
  itemColOne: {
    fontSize: 14,
    color: '#404040',
  },
  itemColTwo: {
    fontSize: 12,
    fontStyle: 'italic',
    color: '#247bcd',
    marginLeft: 17,
    fontWeight: 300,
  },
  itemColThree: {
    fontSize: 14,
    color: '#247bcd',
    '& input': {
      padding: '4px 9px',
      border: '1px solid #e5e5e5',
    },
  },
  itemColLink: {
    textDecoration: 'none',
    color: '#247bcd',
  },
  itemColFour: {
    position: 'relative',
    fontSize: 10,
    color: '#707070',
    marginLeft: 13,
    '&::after': {
      content: "''",
      position: 'absolute',
      height: 2,
      width: 2,
      backgroundColor: '#707070',
      borderRadius: '50%',
      left: -5,
      top: 6,
    },
  },
  itemColEditEmail: {
    marginLeft: 10,
    marginTop: 5,
    '& svg': {
      fontSize: 19,
      cursor: 'pointer',
      color: '#0073b1',
    },
  },
  accountDetails: {
    display: 'flex',
    padding: '42px 29px 20px 29px',
    flexDirection: 'column',
    backgroundColor: '#e5e5e5',
  },

  groupRow: {
    display: 'flex',
    width: '100%',
    marginBottom: 40,
    color: '#404040',
  },
  groupRowIcon: {
    width: 41,
    textAlign: 'left',
  },
  groupRowTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    alignItems: 'center',
    display: 'flex',
    borderBottom: 'solid 1px #e5e5e5',
    width: '100%',
    paddingBottom: 10,
  },
  groupRightWrapper: {
    width: '100%',
  },
  groupRowContent: {
    fontSize: 14,
    color: '#404040',
    marginTop: 15,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& p': {
      marginTop: '1em',
      marginBottom: '1em',
    },
  },
  groupRowItem: {
    display: 'flex',
    width: '100%',
    marginBottom: 14,
  },
  groupRowItemLS: {
    fontWeight: 'bold',
    marginRight: 27,
    width: '33%',
    textAlign: 'right',
  },
  groupRowItemRS: {
    fontSize: 14,
    width: '67%',
    [theme.breakpoints.between(0, 600)]: {
      fontSize: 14,
      width: '60%',
    },
  },
  groupRowItemRSFlag: {
    fontSize: 14,
    width: '67% !important',
  },
  groupRowItemFlag: {
    display: 'flex',
    alignItems: 'center',
    '& .flag': {
      marginRight: 8,
    },
  },
  groupRowItemLink: {
    color: '#247bcd',
    textDecoration: 'none',
  },
  sectionApprove: {
    backgroundColor: '#e5f2ff',
  },
  sectionApproveTitle: {
    fontSize: 14,
    color: '#404040',
  },
  sectionApproveActions: {
    '& button': {
      color: '#FFFFFF',
      padding: '17px 50px',
    },
  },
  sectionApproveBtn: {
    borderRadius: 5,
    backgroundColor: '#0073b1',
  },
  sectionRejectBtn: {
    borderRadius: 5,
    backgroundColor: '#f74872',
  },
  avatar: {
    width: 96,
    height: 96,
    fontSize: '50px',
  },
  avatarIcon: {
    width: '35px',
    height: '35px',
    marginRight: '10px',
    fontSize: '17px',
  },
  avatarMobileIcon: {
    width: '25px',
    height: '25px',
    marginRight: '15px',
    fontSize: '17px',
  },
  nameStyle: {
    color: '#ffffff',
    fontWeight: 'bold',
    fontSize: '20px',
  },
  groupSection: {
    lineHeight: '20px',
    overflowY: 'hidden',
    overflowX: 'auto',
    padding: '7px',
  },
  groupBoxStyle: {
    border: '1px solid #ffffff',
    padding: '10px',
    borderRadius: '12px',
    marginRight: '5px',
    fontSize: '14px',
    minWidth: '100px',
    textAlign: 'center',
    color: '#ffffff',
  },
  lastSeen: {
    fontSize: 14,
    fontWeight: '100',
  },
  postIcon: {
    width: '17px',
  },
  topicList: {
    maxHeight: '115px',
    overflow: 'auto',
  },
}))
